module.exports = __webpack_public_path__ + "media/images/lp/ashinagasan-ad1/img_data04-a07066bc6836bc92fccd4f9f78ad190d.png";